import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { PushNotificationToken } from './push-notifications-token.interfaces';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsV2Service {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  /**
   * Add or update a push notification token
   * @param token Push notification token
   */
  addToken(token: PushNotificationToken): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtpushnotifications`;
    return this.http.post<boolean>(url, token);
  }

  /**
   * Delete a push notification token
   * @param token Push notification token
   */
  deleteToken(token: string): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtpushnotifications/${token}`;
    return this.http.delete<boolean>(url);
  }
}
